import Radium from '@flipdish/radium';
import * as React from 'react';
import * as Api from '../../Api';
const tinycolor = require('tinycolor2');

interface Props {
  OnClick: () => any;
  IsOpen: boolean;
  ItemCount: number;
  InsideDeliveryZone: boolean;
  AcceptPreOrders: boolean;
  translate: any;
  Style:
    | 'default'
    | 'primary'
    | 'success'
    | 'info'
    | 'warning'
    | 'danger'
    | 'link';
  AppDesignScheme: Api.AppDesignScheme;
}

interface State {}

export class CheckoutButton extends React.Component<Props, State> {
  public buttonState = (): { message: string; disabled: boolean } => {
    const {
      InsideDeliveryZone,
      ItemCount,
      translate,
      IsOpen,
      AcceptPreOrders
    } = this.props;

    // TODO - check against minimun order value.
    const tooFewItems = ItemCount < 1;

    if (!InsideDeliveryZone) {
      return {
        disabled: true,
        message: translate('Cannot_deliver_checkout')
      };
    }

    if (IsOpen) {
      return {
        disabled: tooFewItems,
        message: translate('Checkout')
      };
    }

    if (AcceptPreOrders) {
      return {
        disabled: tooFewItems,
        message: translate('Preorder')
      };
    }

    return {
      disabled: true,
      message: translate('Closed')
    };
  };

  public render(): JSX.Element {
    const { AppDesignScheme, OnClick } = this.props;

    const { message, disabled } = this.buttonState();

    const styles = {
      buttonSecondary: {
        backgroundColor: AppDesignScheme.Secondary,
        ':hover': {},
        ':active': {},
        ':focus': {}
      },
      buttonActive: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(10)
          .toString()
      },
      buttonHover: {
        backgroundColor: tinycolor(AppDesignScheme.Secondary)
          .darken(5)
          .toString()
      },
      primary: {
        color: AppDesignScheme.Primary
      }
    };

    return (
      <button
        className="fd-button fd-button--full-width fd-button--secondary"
        disabled={disabled}
        onClick={OnClick}
        key="checkout-button"
        style={
          [
            styles.buttonSecondary,
            Radium.getState(this.state, 'checkout-button', ':active')
              ? styles.buttonActive
              : Radium.getState(this.state, 'checkout-button', ':hover')
              ? styles.buttonHover
              : null
          ] as any
        }
      >
        <h3 className="clear-margins primary" style={styles.primary}>
          {message}
        </h3>
      </button>
    );
  }
}

export default Radium(CheckoutButton);
